var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hyCheck",on:{"click":function($event){return _vm.ss()}}},[_c('span',{class:[_vm.a==true?_vm.b:'checkbox-button']}),_c('span',{class:[_vm.a==true?'checkbox-text':'']},[_vm._v("\n\t\t全选\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }